import { QuestionnaireFormResponse } from 'types/ui';
import fetchWebApi from 'api/fetchWebApi';

const getQuestionnaireApiCall = async (): Promise<QuestionnaireFormResponse> =>
  fetchWebApi('/questionnaire/se-aml');

export default getQuestionnaireApiCall;
